import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/pegasus/Documents/nobinpegasus.github.io/src/layouts/MDXLayout.tsx";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p><a parentName="p" {...{
        "href": "https://aclanthology.org/2024.bucc-1.8/",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`BnPC: A Gold Standard Corpus for Paraphrase Detection in Bangla, and its Evaluation`}</a><br parentName="p"></br>{`
`}{`Sourav Saha, `}<strong parentName="p"><em parentName="strong">{`Zeshan Ahmed Nobin`}</em></strong>{`, Mufassir Ahmad Chowdhury, Md. Shakirul Hasan Khan Mobin, Mohammad Ruhul Amin and Sudipta Kar`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      